import MappingPresetModal from './MappingPresetModal';

export default MappingPresetModal;
